import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ffb1902&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5ffb1902&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb1902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ffb1902')) {
      api.createRecord('5ffb1902', component.options)
    } else {
      api.reload('5ffb1902', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5ffb1902&scoped=true", function () {
      api.rerender('5ffb1902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/communityEducation/index.vue"
export default component.exports